// extracted by mini-css-extract-plugin
export default {"container":"Recommendations_container__zckFD","prices":"Recommendations_prices__fKlhE","priceOld":"Recommendations_priceOld__FkXSs"};